import { uuid } from 'vue-uuid';

function getAnonIdFromUrl() {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get('anonId');
}

export default {
  getId() {
    const urlAnonId = getAnonIdFromUrl();
    if (urlAnonId) {
      return urlAnonId;
    }
    if (window.appAnonymousId) {
      return window.appAnonymousId;
    }
    let anonymousUid = localStorage.getItem('riseup.anonymousUid');
    if (!anonymousUid) {
      anonymousUid = `anon-${uuid.v4()}`;
      localStorage.setItem('riseup.anonymousUid', anonymousUid);
    }
    return anonymousUid;
  },
};
